/* tslint:disable */
/* eslint-disable */
/**
 * BusService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { GetSeatsBulkRequest } from '../model';
// @ts-ignore
import { ReservedSeatResultDto } from '../model';
// @ts-ignore
import { ServiceInfoDto } from '../model';
/**
 * GetSeatsApiApiGetSeatsByReserveIdGet - axios parameter creator
 * 
 * @param {number} [reserveId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetSeatsApiApiGetSeatsByReserveIdGetAxiosParamCreator (reserveId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetSeatsByReserveId`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (reserveId !== undefined) {
        localVarQueryParameter['reserveId'] = reserveId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetSeatsApiApiGetSeatsGet - axios parameter creator
 * 
 * @param {number} [busId] 
 * @param {boolean} [convertFemaleToMale] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetSeatsApiApiGetSeatsGetAxiosParamCreator (busId?: number, convertFemaleToMale?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetSeats`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (busId !== undefined) {
        localVarQueryParameter['busId'] = busId;
    }

    if (convertFemaleToMale !== undefined) {
        localVarQueryParameter['convertFemaleToMale'] = convertFemaleToMale;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetSeatsApiApiV2BulkUpdateSeatsPost - axios parameter creator
 * 
 * @param {boolean} [convertFemaleToMale] 
 * @param {GetSeatsBulkRequest} [getSeatsBulkRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetSeatsApiApiV2BulkUpdateSeatsPostAxiosParamCreator (convertFemaleToMale?: boolean, getSeatsBulkRequest?: GetSeatsBulkRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/v2/BulkUpdateSeats`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (convertFemaleToMale !== undefined) {
        localVarQueryParameter['convertFemaleToMale'] = convertFemaleToMale;
    }



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getSeatsBulkRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetSeatsApiApiV2GetSeatsGet - axios parameter creator
 * 
 * @param {number} [busId] 
 * @param {boolean} [convertFemaleToMale] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetSeatsApiApiV2GetSeatsGetAxiosParamCreator (busId?: number, convertFemaleToMale?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/v2/GetSeats`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (busId !== undefined) {
        localVarQueryParameter['busId'] = busId;
    }

    if (convertFemaleToMale !== undefined) {
        localVarQueryParameter['convertFemaleToMale'] = convertFemaleToMale;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiGetSeatsByReserveIdGet operation in GetSeatsApi.
 * @export
 * @interface GetSeatsApiApiGetSeatsByReserveIdGetRequest
 */
export interface GetSeatsApiApiGetSeatsByReserveIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof GetSeatsApiApiGetSeatsByReserveIdGet
     */
    readonly reserveId?: number
}

/**
 * Request parameters for apiGetSeatsGet operation in GetSeatsApi.
 * @export
 * @interface GetSeatsApiApiGetSeatsGetRequest
 */
export interface GetSeatsApiApiGetSeatsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof GetSeatsApiApiGetSeatsGet
     */
    readonly busId?: number

    /**
     * 
     * @type {boolean}
     * @memberof GetSeatsApiApiGetSeatsGet
     */
    readonly convertFemaleToMale?: boolean
}

/**
 * Request parameters for apiV2BulkUpdateSeatsPost operation in GetSeatsApi.
 * @export
 * @interface GetSeatsApiApiV2BulkUpdateSeatsPostRequest
 */
export interface GetSeatsApiApiV2BulkUpdateSeatsPostRequest {
    /**
     * 
     * @type {boolean}
     * @memberof GetSeatsApiApiV2BulkUpdateSeatsPost
     */
    readonly convertFemaleToMale?: boolean

    /**
     * 
     * @type {GetSeatsBulkRequest}
     * @memberof GetSeatsApiApiV2BulkUpdateSeatsPost
     */
    readonly getSeatsBulkRequest?: GetSeatsBulkRequest
}

/**
 * Request parameters for apiV2GetSeatsGet operation in GetSeatsApi.
 * @export
 * @interface GetSeatsApiApiV2GetSeatsGetRequest
 */
export interface GetSeatsApiApiV2GetSeatsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof GetSeatsApiApiV2GetSeatsGet
     */
    readonly busId?: number

    /**
     * 
     * @type {boolean}
     * @memberof GetSeatsApiApiV2GetSeatsGet
     */
    readonly convertFemaleToMale?: boolean
}

/**
* 
* @param {GetSeatsApiApiGetSeatsByReserveIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetSeatsApiApiGetSeatsByReserveIdGet(requestParameters: GetSeatsApiApiGetSeatsByReserveIdGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetSeatsApiApiGetSeatsByReserveIdGetAxiosParamCreator(requestParameters.reserveId, options, configuration);
    const request: () => AxiosPromise<Array<ReservedSeatResultDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetSeatsApiApiGetSeatsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetSeatsApiApiGetSeatsGet(requestParameters: GetSeatsApiApiGetSeatsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetSeatsApiApiGetSeatsGetAxiosParamCreator(requestParameters.busId, requestParameters.convertFemaleToMale, options, configuration);
    const request: () => AxiosPromise<ServiceInfoDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetSeatsApiApiV2BulkUpdateSeatsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetSeatsApiApiV2BulkUpdateSeatsPost(requestParameters: GetSeatsApiApiV2BulkUpdateSeatsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetSeatsApiApiV2BulkUpdateSeatsPostAxiosParamCreator(requestParameters.convertFemaleToMale, requestParameters.getSeatsBulkRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetSeatsApiApiV2GetSeatsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetSeatsApiApiV2GetSeatsGet(requestParameters: GetSeatsApiApiV2GetSeatsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetSeatsApiApiV2GetSeatsGetAxiosParamCreator(requestParameters.busId, requestParameters.convertFemaleToMale, options, configuration);
    const request: () => AxiosPromise<ServiceInfoDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
